import { axiosInstance as axios } from "services";

export const publishSync = async ({ type }) => {
  const { data } = await axios.post(`/pricing/master/sync-status/publish`, { type });
  if (!data.success) throw new Error(data.error?.message || "Failed to publish updates");
  return data.result;
};
